// @flow

import React from 'react';
import {connect} from 'react-redux';

import {CurrentUserSelector} from 'app/current-user/api';
import {getContentType} from 'app/utils/content-type';
import {
  runWhenAnyModelMatch,
  type ModelSubscribedComponentPropsType,
} from 'app/subscriptions';
import {keepUpdatedEnhancer} from 'app/general/keepUpdatedEnhancer';
import {gt} from 'app/utils/i18n';
import type {StoreShapeType} from 'app/reducers/types';
import {SearchItemsSelectSingle} from 'app/search/components/SearchItemsSelect';
import type {SearchItemType, SearchTypeGroup} from 'app/search/types';

const teamCt = getContentType('team');

type TeamOrRole = {
  object_id: string | number,
  content_type: SearchTypeGroup,
};

type OwnProps = {|
  value?: TeamOrRole,
  queryParams?: TeamOrRole,
  placeholder?: string,
  onChange: (string: string, contentType?: SearchTypeGroup) => Promise<any>,
|};

type StateProps = {|
  isSuper: boolean,
  currentUserId?: number,
|};

type ConnectedProps = {|
  dispatch: any,
  ...OwnProps,
  ...StateProps,
|};

type Props = {
  ...ConnectedProps,
  ...ModelSubscribedComponentPropsType,
};

class BaseDashboardFilterbarTeamsAndRoles extends React.PureComponent<Props> {
  constructor(props) {
    super(props);
    this.props.onModelChange(this.handleModelChange);
  }

  handleModelChange = (message) => {
    return runWhenAnyModelMatch(message, 'team', () => null);
  };

  getLabelWithoutIcon = (roleOrTeam: SearchItemType) => {
    if (
      roleOrTeam.content_type === 'role' &&
      roleOrTeam.metadata != null &&
      roleOrTeam.metadata.team != null
    ) {
      return (
        <span>
          {roleOrTeam.name} (<i className={teamCt.icon}></i>{' '}
          {roleOrTeam.metadata.team.name})
        </span>
      );
    } else {
      return <span>{roleOrTeam.name}</span>;
    }
  };

  render() {
    const {value, queryParams, onChange, placeholder} = this.props;
    return (
      <SearchItemsSelectSingle
        selectProps={{
          autoFocus: true,
          getLabel: this.getLabelWithoutIcon,
        }}
        disabled={false}
        placeholder={placeholder || gt('Filter by team or role...')}
        params={{
          ct: 'team,role',
          ordering: 'name',
        }}
        lazyFetch={true}
        queryParams={queryParams}
        selected={value}
        onChange={onChange}
      />
    );
  }
}

const mapStateToProps = (state): StateProps => {
  const user = CurrentUserSelector(state).data;
  return {
    isSuper: user.is_super_manager || user.is_super_teammate || false,
    currentUserId: user.id,
  };
};

export const DashboardFilterbarTeamsAndRoles = connect<
  ConnectedProps,
  OwnProps,
  StateProps,
  _,
  StoreShapeType,
  _
>(mapStateToProps)(
  keepUpdatedEnhancer<ConnectedProps>(BaseDashboardFilterbarTeamsAndRoles)
);
